import queryString from 'query-string';
import React, { Component, PropTypes } from 'react';
import DocumentTitle from 'react-document-title';
import { defineMessages, FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updatePath } from 'redux-simple-router';

import HomeLibrarySelector from 'components/common/HomeLibrarySelector';
import HomePageIntro from 'components/customization/HomePageIntro';
import PurposeCategoryList from 'containers/PurposeCategoryList';
import homePageSelector from 'selectors/containers/homePageSelector';
import { changeSearchFilters } from 'actions/uiActions';
import { fetchUnits } from 'actions/unitActions';

const messages = defineMessages({
  title: {
    id: 'home.title',
    defaultMessage: 'Etusivu - Varaamo',
  },
});

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.onFiltersChange = this.onFiltersChange.bind(this);
    this.handleNewFilters = this.handleNewFilters.bind(this);
  }

  componentDidMount() {
    const { actions } = this.props;
    actions.fetchUnits();
  }

  onFiltersChange(newFilters) {
    this.props.actions.changeSearchFilters(newFilters);
    this.handleNewFilters(newFilters);
  }

  handleNewFilters(newFilters) {
    const { actions } = this.props;
    let filters;
    if (newFilters) {
      filters = Object.assign({}, this.props.filters, newFilters);
    } else {
      filters = this.props.filters;
    }
    filters = { unit: filters.unit };

    actions.updatePath(`/?${queryString.stringify(filters)}`);
  }

  render() {
    const { filters, intl, isFetchingUnits, unitOptions } = this.props;
    return (
      <DocumentTitle title={intl.formatMessage(messages.title)}>
        <div>
          <HomePageIntro />
          <HomeLibrarySelector
            isFetchingUnits={isFetchingUnits}
            onFiltersChange={this.onFiltersChange}
            filters={filters}
            unitOptions={unitOptions}
          />
          <h2 id="purpose-category-header">
            <FormattedMessage
              id="home.what_purpose"
              defaultMessage="Mitä haluat tehdä?"
            />
          </h2>
          <PurposeCategoryList
            selectedUnit={filters.unit}
          />
        </div>
      </DocumentTitle>
    );
  }
}

HomePage.propTypes = {
  actions: PropTypes.object.isRequired,
  filters: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
  isFetchingUnits: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  unitOptions: PropTypes.array.isRequired,
  units: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
  const actionCreators = {
    changeSearchFilters,
    fetchUnits,
    updatePath,
  };

  return { actions: bindActionCreators(actionCreators, dispatch) };
}

export default injectIntl(connect(homePageSelector, mapDispatchToProps)(HomePage));



/** WEBPACK FOOTER **
 ** ./app/containers/HomePage.js
 **/